<template>
    <div ref="el" class="ea-chart"></div>
</template>

<script>
import * as echarts from "echarts";

export default {
    name: "EChart",
    props: {
        option: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            chart: null,
            resizeObserver: null,
        };
    },
    watch: {
        option() {
            this.render();
        },
    },
    mounted() {
        this.chart = echarts.init(this.$refs.el);
        this.chart.on("click", (params) => this.$emit("chart-click", params));
        this.render();
        // 섹션 높이가 레이아웃에 따라 변하므로 window resize만으로는 부족하다
        this.resizeObserver = new ResizeObserver(() => this.chart && this.chart.resize());
        this.resizeObserver.observe(this.$refs.el);
    },
    beforeDestroy() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.chart) this.chart.dispose();
        this.chart = null;
    },
    methods: {
        render() {
            if (!this.chart) return;
            if (!this.option) {
                this.chart.clear();
                return;
            }
            this.chart.setOption(this.option, true);
        },
    },
};
</script>

<style scoped>
.ea-chart {
    width: 100%;
    height: 100%;
    min-height: 0;
}
</style>
